<template>
  <div class="layout-content-list dispatch-driver-add">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>公司</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/auth/management' }"> 授权管理 </el-breadcrumb-item>
      <el-breadcrumb-item>授权历史</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="授权列表" name="auth"></el-tab-pane>
        <el-tab-pane label="管理列表" name="manage"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">企业名称</span>
        <el-input
          v-model.trim="filter.companyName"
          style="width: 220px"
          :placeholder="activeName == 'auth' ? '请输入授权账号的企业名称' : '请输入管理账号的企业名称'"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">管理员姓名</span>
        <el-input
          v-model.trim="filter.userName"
          style="width: 220px"
          :placeholder="activeName == 'auth' ? '请输入授权账号的管理员姓名' : '请输入管理账号的管理员姓名'"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">管理员电话</span>
        <el-input
          v-model.trim="filter.userMobile"
          style="width: 220px"
          :placeholder="activeName == 'auth' ? '请输入授权账号的管理员电话' : '请输入管理账号的管理员电话'"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">授权状态</span>
        <el-select style="width: 120px" v-model="filter.authStatus" placeholder="请选择" class="track-elselect">
          <el-option v-for="(item, idx) in authStatusList" :label="item.label" :value="item.value" :key="idx">
          </el-option>
        </el-select>
      </div>

      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="back" id="auto-2">返回</el-button>
        <el-button type="primary" size="small" @click="search" id="auto-2">筛选</el-button>
      </div>
    </div>

    <div class="table-custom-box no-all mt-10" id="auto-4">
      <el-table :data="tableData.data" border :max-height="550">
        <el-table-column prop="authTime" label="授权时间" min-width="90">
          <template v-slot="scope">
            <span>{{ scope.row.authTime | stamp2TextDateFull }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rowUpdateTime" label="更新时间" min-width="90">
          <template v-slot="scope">
            <span>{{ scope.row.rowUpdateTime | stamp2TextDateFull }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" min-width="90"> </el-table-column>
        <el-table-column prop="userName" label="管理员姓名" min-width="90"> </el-table-column>
        <el-table-column prop="userMobile" label="管理员电话" min-width="90"> </el-table-column>
        <el-table-column prop="authStatus" label="状态" min-width="90">
          <template v-slot="scope">
            <span v-if="scope.row.authStatus === 0">未授权</span>
            <span v-if="scope.row.authStatus === 1">已授权</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="90">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="small"
              v-if="scope.row.authStatus === 1"
              @click="handleCancelAuth(scope.row)"
              >{{ activeName === 'auth' ? '取消授权' : '放弃管理' }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="scope.row.authStatus === 0 && activeName === 'auth'"
              @click="handleAuth(scope.row)"
              >授权</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="authStatus" label="查看协议" width="100" v-if="activeName == 'auth'">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="pageNum"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
export default {
  name: 'AuthHistory',
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      activeName: 'auth',
      cache: {},
      filter: { companyName: '', userName: '', userMobile: '', authStatus: -1 },
      lineIds: [],
      tableData: {
        data: [],
        total: 0
      },
      authStatusList: [
        { label: '全部', value: -1 },
        { label: '已授权', value: 1 },
        { label: '未授权', value: 0 }
      ]
    };
  },
  async created() {
    this.search();
  },
  methods: {
    handleTabClick(val) {
      this.search();
    },
    search() {
      this.cache = { ...this.filter, queryType: this.activeName === 'auth' ? 1 : 2 };
      this.pageNum = 1;
      this.axiosRequest();
    },
    axiosRequest() {
      const options = { ...this.cache, pageNum: this.pageNum, pageSize: this.pageSize };
      axios.post(api.authManageList, options).then(async res => {
        this.tableData = res.data;
      });
    },
    currentChange(val) {
      this.pageNum = val;
      this.axiosRequest();
    },
    async handleAuth(item) {
      await axios.post(api.updateAuthStatus, { id: item.id, authStatus: 1 });
      this.search();
    },
    async handleCancelAuth(item) {
      if (this.activeName === 'manage') {
        this.$confirm('取消管理后，如需恢复管理权限，需授权账号重新授权，确认是否取消？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            await axios.post(api.updateAuthStatus, { id: item.id, authStatus: 0 });
            this.search();
          })
          .catch(() => {});
      } else {
        await axios.post(api.updateAuthStatus, { id: item.id, authStatus: 0 });
        this.search();
      }
    },
    back() {
      this.$router.push({ path: '/auth/management' });
    },
    handleView(item) {
      window.open(item.htmlUrl);
    }
  }
};
</script>
<style lang="postcss">
.dispatch-driver-add {
}
</style>
